module.exports = __webpack_public_path__ + "static/media/night06.48301471.jpg";